import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) { toast.error("Passwords do not match"); return; }
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! Sign in.");
      nav("/login");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <h1 className="font-display text-3xl tracking-tight">Reset password</h1>
      <p className="text-sm text-muted-foreground mt-1">Enter your new password below.</p>
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
        <div>
          <label className="label-eyebrow text-muted-foreground">New password</label>
          <div className="relative mt-2">
            <input type={showPassword ? "text" : "password"} className="input-base pr-10" required minLength={6}
              placeholder="Minimum 6 characters" value={password} onChange={e => setPassword(e.target.value)} data-testid="reset-password" />
            <button type="button" onClick={() => setShowPassword(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-slate-600">
              {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
        </div>
        <div>
          <label className="label-eyebrow text-muted-foreground">Confirm new password</label>
          <div className="relative mt-2">
            <input type={showPassword ? "text" : "password"} className={`input-base pr-10 ${confirmPassword && password !== confirmPassword ? "border-red-400" : ""}`}
              required minLength={6} placeholder="Re-enter password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
            <button type="button" onClick={() => setShowPassword(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-slate-600">
              {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
          {confirmPassword && password !== confirmPassword && (
            <p className="text-xs text-red-500 mt-1">Passwords do not match</p>
          )}
        </div>
        <button className="btn-primary w-full" data-testid="reset-submit">Reset password</button>
      </form>
    </div>
  );
}
